<!--下拉单选组件-->
<template>
  <span class="selection-body">
    <span style="font-size: .12rem;margin-top:0.05rem" :style="getColorStyleById('fontColor')"
      v-if="title!=undefined &&title.length>0" :title="title">{{title}}:</span>
    <div class="selection" :style="selectionStyle">
      <p @click.stop="showUl = !showUl" :id="titleId" ref="title" :style="getInputBackground">{{nowName}}</p>
      <ul class="custom-scrollbar" style="overflow-x: hidden;" v-show="showUl" ref="ul">
        <li v-for="(item,index) in list" :key='index' @click.stop="checkItem(item,index)"><img
            :src="getImg(index)" />{{getName(item)}}</li>
      </ul>
    </div>
  </span>
</template>

<script>
  import resourcesStore from '@/cache/resourcesStore.js'
  /**
   * nameKey：下拉框显示的名字字段
   * list:下拉宽的数据
   * autoCheck:默认选中
   * disable:禁用 true 为禁用
   */
  export default {
    components: {},
    props: {
      selectionStyle: {
        type: Object,
        default: () => {
          return {}
        }
      },
      title: {
        type: String,
        default: () => {
          return ''
        }
      },
      label: {
        type: String,
        default: () => {
          return '未选中'
        }
      },
      nameKey: {
        type: String,
        default: () => {
          return 'name'
        }
      },
      list: {
        type: Array,
        default: () => {
          return []
        }
      },
      autoCheck: {},
      disable: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        nowIndex: -1,
        showUl: false,
        titleId: randomPkid(),
        isAddClick: false,
      }
    },
    created () {
    },
    mounted () {
      this.reset()
      var titleRect=this.$refs.title.getBoundingClientRect()
    },
    destroyed () {

    },
    computed: {
      nowName () {
        if(isempty(this.list)) {
          return this.getName(undefined)
        }
        return this.getName(this.list[this.nowIndex])
      },
      getInputBackground () {
        if(!this.showUl) {
          return this.getBackgroudImageStyle('multipleSelection/arrowDown.png')
        }
        return this.getBackgroudImageStyle('multipleSelection/arrowUp.png')
      },
      getBackgroudImageStyle () {
        return resourcesStore.getters.getBackgroudImageStyle
      },
      getColorStyleById () {
        return resourcesStore.getters.getColorStyleById
      },
    },
    watch: {
      list (nv,ov) {
        this.nowIndex=-1
        this.reset()
      },
      nowIndex (nv,ov) {
        // console.log(this.list[nv],'list[nv]')
        this.$emit("checkItem",this.list[nv])
      },
      showUl (nv,ov) {
        if(nv) {
          this.addClickToClose()
        }
      },
      autoCheck (nv,ov) {
        this.reset()
      }
    },
    methods: {
      reset () {
        //未选中状态则使用默认的autoCheck列表
        if(!isempty(this.autoCheck)&&!isempty(this.list)) {
          if(typeof this.autoCheck=='number') {
            //如果是单个的数字就直接来吧
            this.$set(this,'nowIndex',this.autoCheck)
          } else if(this.autoCheck!=false) {
            //默认是选中第一个
            this.nowIndex=0
          }
        }
      },
      addClickToClose () {
        var that=this

        function clickToClose (event) {
          if(event.target.id==that.titleId) {
            return
          }
          if(that.showUl==true) {
            that.showUl=false
          }
          document.removeEventListener('click',clickToClose,true)
          that.isAddClick=false
        }
        if(!this.isAddClick) {
          this.isAddClick=true
          document.addEventListener('click',clickToClose,true)
        }
      },
      getName (item) {
        if(isempty(item)) {
          return this.label
        }
        return item[this.nameKey]
      },
      checkItem (item,index) {
        if(this.disable) {
          return
        }
        this.showUl=false
        // console.log(this.index,'index')
        this.nowIndex=index
      },
      getImg (index) {
        if(index==this.nowIndex) {
          return resourcesStore.getters.getResourcesByName("checkBox/checked.png")
        }
        return resourcesStore.getters.getResourcesByName("checkBox/unchecked.png")
      }
    }
  }
</script>

<style scoped>
  .hideBar {
    /* color:black */
  }

  .selection-body {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    font-size: .12rem;
    padding: 0 .1rem;
  }

  .selection {
    text-align: center;
    min-width: 1.1rem;
    position: relative;
    font-size: .14rem;
    color: white;
  }

  .selection>p {
    background-color: white;
    height: .25rem;
    width: 100%;
    line-height: .25rem;
    text-align: center;
    padding: .02rem 0;
    border-radius: .05rem;
    white-space: nowrap;
    overflow: auto;
    font-size: .12rem;
    cursor: pointer;
    color: black;
  }

  .selection ul {
    position: absolute;
    width: calc(100% - 2px);
    top: 36px;
    z-index: 1000;
    background: white;
    list-style: none;
    border: solid #CCCCCC .01rem;
    max-height: 2rem;
    border-radius: .05rem;
  }

  .selection ul>li {
    height: .3rem;
    line-height: .3rem;
    padding: .02rem;
    padding-left: .1rem;
    border: solid #CCCCCC .01rem;
    border-width: .01rem 0 0 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
    color: black;
  }

  .selection ul>li:first-of-type {
    border-top: 0;
  }

  .selection ul>li>img {
    width: .2rem;
    height: .2rem;
    margin-right: .1rem;
  }
</style>